export default __webpack_public_path__ + "static/media/group-option-female-selected.ccf36cae.svg";